/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { WorkspaceObject } from 'jotai/workspace';
import { SystemWorkspaceId } from 'jotai/workspace/SystemWorkspaceId';
import { SanctioningBodyEnum } from 'models/viewModels';
import { blankWorkspace } from './BlankWorkspace';

export const blankNascarWorkspace: WorkspaceObject = {
  ...blankWorkspace,
  id: SystemWorkspaceId.BlankNascar,
  name: 'Blank NASCAR Workspace',
  slug: 'blank-nascar',
  sanctioningBody: SanctioningBodyEnum.NASCAR,
};
